/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
/* eslint-disable consistent-return */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import Web3 from 'web3';
import EthIco from 'modules/common/assests/images/binance.png';
import PlaceHolderImage from 'modules/common/assests/images/Artboard-1-24.png';
import { useDispatch, useSelector } from 'react-redux';
import { purchaseNFTLoader } from 'modules/artworks/selector';
import { purchaseNFTsSlice } from 'modules/artworks/slice';
import toast from 'react-hot-toast';
import { ENVIRONMENT } from 'configs';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const web3 = new Web3(
  Web3.givenProvider || 'ws://some.local-or-remote.node:8546'
);

const NFTCard = ({
  image,
  title,
  price,
  seller,
  token_id,
  owner,
  modal,
  setTokenId,
}) => {
  const [account, setAccount] = useState();

  const dispatch = useDispatch();

  const loading = useSelector(purchaseNFTLoader);

  const purchaseNFTs = async () => {
    const tokenData = { tokenId: token_id, price };
    if (account === seller) {
      return toast('Your are the owner of this NFT.', {
        duration: 1500,
        icon: '⚠️',
      });
    }
    await Promise.resolve(
      dispatch(purchaseNFTsSlice.actions.purchaseNFT(tokenData))
    );
  };

  const getMyAccount = async () => {
    const accounts = await web3.eth.getAccounts();
    setAccount(accounts[0]);
  };

  const tokenID = () => {
    setTokenId(token_id);
  };

  useEffect(() => {
    getMyAccount();
    if (setTokenId) {
      tokenID();
    }
  }, []);

  return (
    <div className='bg-black h-96 w-72 shadow-lg rounded-xl my-4 flex flex-col hover:scale-105 cursor-pointer nft-card ease-in duration-500 relative'>
      <div>
        <LazyLoadImage
          alt='NFT images'
          effect='blur'
          placeholderSrc={PlaceHolderImage}
          className='rounded-t-xl h-60 2xl:h-64 w-full'
          src={`https://ipfs.io/ipfs/${image}`}
        />
      </div>
      <div>
        <h1 className='font-bold text-white mx-4 mt-2'>
          {title.substring(0, 25)}
        </h1>
        <div className='mx-4'>
          <p className='text-xs text-gray-300 font-bold mt-2'>Price</p>
          <div className='flex mt-1 items-center'>
            <img src={EthIco} alt='ethereum-icon' className='h-5' />
            <p className='text-white font-bold pl-1'>
              {price / 10 ** 18} {ENVIRONMENT.CURRENCY}
            </p>
          </div>
        </div>
        {owner !== account && !modal && !loading ? (
          <button
            onClick={purchaseNFTs}
            className='rounded-b-xl w-full flex justify-center items-center text-[#40A838] buy-button hover:bg-[#40A838] hover:text-white ease-in duration-500 font-medium absolute bottom-0 py-0 xl:py-3'
          >
            Buy Now
          </button>
        ) : loading ? (
          <button className='rounded-b-xl w-full h-16 lg:h-12 flex justify-center items-center text-[#40A838] buy-button hover:bg-[#40A838] hover:text-white ease-in duration-500 font-medium absolute cursor-wait bottom-0'>
            <svg
              className='mr-3 h-5 w-5 animate-spin text-[#40A838]'
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
            >
              <circle
                className='opacity-25'
                cx='12'
                cy='12'
                r='10'
                stroke='currentColor'
                strokeWidth='4'
              />
              <path
                className='opacity-75'
                fill='currentColor'
                d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
              />
            </svg>
            Loading...
          </button>
        ) : (
          <button
            onClick={modal}
            className='rounded-b-xl w-full h-16 lg:h-12 flex justify-center items-center text-[#40A838] buy-button hover:bg-[#40A838] hover:text-white ease-in duration-500 font-medium absolute bottom-0'
          >
            Resell
          </button>
        )}
      </div>
    </div>
  );
};

export default NFTCard;
